export { default } from './language-cookie-setter'
